import { Card, CardBody, Container } from 'reactstrap';
import Breadcrumbs from '../../../../coreComponents/breadcrumbs';
import AjaxSourcedData from '../../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useGetUnprocessedTranscriptionsQuery } from '../../../../reduxToolkit/reducers/usersSlice';
import { NoDataComponent } from '../../../formsAndTable/forms/formControls/NoDataComponent';
import { getUnprocessedTransactionsTableColumns } from '../../../../data/formsAndTable/tables/dataTables/DataSource';
import { UnprocessedHeadingTooltip } from './UnprocessedHeadingTooltip';

export const UnprocessedTranscriptions: React.FC = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');
  const [sortKey, setSortKey] = useState<string>('createdAt');
  const [search, setSearch] = useState<string>('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const { data: unprocessedTranscriptions } = useGetUnprocessedTranscriptionsQuery({
    page,
    perPage,
    sort,
    sortKey,
    search: debouncedSearch,
  });
  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(id);
  }, [search]);

  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <>
      <Breadcrumbs
        mainTitle={t('control.unprocessed.title')}
        tooltip={<UnprocessedHeadingTooltip />}
      />
      <Container fluid>
        <Card>
          <CardBody>
            <AjaxSourcedData
              data={unprocessedTranscriptions?.items || []}
              columns={getUnprocessedTransactionsTableColumns(t, viewerTz)}
              pagination={true}
              paginationServer={true}
              paginationPerPage={perPage}
              paginationDefaultPage={1}
              paginationTotalRows={unprocessedTranscriptions?.total || 0}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage, p) => {
                setPerPage(newPerPage);
                setPage(1); // or p, depending on your UX
              }}
              sortServer
              onSort={(column, direction) => {
                // column.selector or column.sortField depending on your column defs
                const key = (column as any).sortField ?? (column as any).selector;
                setSort(direction);
                setSortKey(key);
              }}
              defaultSortAsc={false}
              searchServer
              searchText={search}
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
              //   conditionalRowStyles={conditionalRowStyles}
              paginationRowsPerPageOptions={[20, 50, 100]}
              noDataComponent={<NoDataComponent />}
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
};
